import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { FIELD_TYPES } from '../../../constants';
import { RatingInputFieldWUT } from '../../../ui/rating-input-field';
export const RatingInputWUT = props => {
  const fieldType = FIELD_TYPES.RATING_INPUT;
  return /*#__PURE__*/React.createElement(RatingInputFieldWUT, _extends({}, props, {
    fieldType: fieldType
  }));
};
//# sourceMappingURL=rating-input-wut.js.map